import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { ShoppingCartProvider } from "./contexts/ShoppingCartContext";
import "./i18n/config";
import MenuPage from "./pages/menu/MenuPage";
import NotFoundPage from "./pages/not-found/NotFoundPage";
import RestaurantPage from "./pages/restaurant/RestaurantPage";
import CategoryPage from "./pages/menu/CategoryPage";
import { ChatbotProvider } from "./chatbot/contexts/ChatbotContext";
import { BranchProvider, useBranch } from "./contexts/BranchContext";
import { GoogleMapsProvider } from "./contexts/GoogleMapsContext";
import DocumentHeadManager from "./components/DocumentHeadManager";
import { initGA, logPageView } from "./utils/analytics";
import { ViewModeProvider } from "./contexts/ViewModeContext";
import { useDeviceSignature } from "./utils/deviceSignature";
import ComingSoon from "./LandingPage/UserLandingPages/ComingSoon";
import RestaurantMenuLanding from "./LandingPage/adminLandingPage/LandingPage";
import UserLandingPage from "./LandingPage/UserLandingPages/userLandingPage";

// Component that uses useLocation - must be inside Router
function AppContent() {
  const [hasLandingPage, setHasLandingPage] = useState(false);
  const { branchData } = useBranch();

  const location = useLocation();
  useEffect(() => {
    if (branchData?.branch.has_landing === true) {
      setHasLandingPage(true);
    } else {
      setHasLandingPage(false);
    }
  }, [branchData]);

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div
      className="flex flex-col min-h-screen overflow-x-hidden"
      onContextMenu={(e) => e.preventDefault()}
    >
      <main className="flex-grow ">
        <Routes>
          {/* Home route */}
          <Route path="/" element={<UserLandingPage />} />


          {/* {hasLandingPage && (
            <Route path="/:branch_key" element={<UserLandingPage />} />
          )} */}

          {/* Branch routes with new structure: /:branchId/branch and /:branchId/menu */}
          <Route
            path="/:branch_key/menu"
            element={
              <ShoppingCartProvider>
                <BranchProvider>
                  <GoogleMapsProvider>
                    <ChatbotProvider useMockApi={false}>
                      <DocumentHeadManager />
                      <RestaurantPage />
                    </ChatbotProvider>
                  </GoogleMapsProvider>
                </BranchProvider>
              </ShoppingCartProvider>
            }
          >
            <Route index element={<MenuPage />} />
            <Route path=":categoryId" element={<CategoryPage />} />
          </Route>

          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  const { i18n } = useTranslation();
  const signature = useDeviceSignature();

  // Effect to set document direction based on language
  useEffect(() => {
    // Set the dir attribute on the html element
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
    sessionStorage.removeItem("restaurant-item-cards");
    sessionStorage.removeItem("restaurant-order-note");
    localStorage.removeItem("session_id");
    if (i18n.language === "ar") {
      document.documentElement.classList.add("rtl");
    } else {
      document.documentElement.classList.remove("rtl");
    }
  }, [i18n.language]);

  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <BranchProvider>
        <ViewModeProvider>
          <AppContent />
        </ViewModeProvider>
      </BranchProvider>
    </Router>
  );
}

export default App;
